module.exports = __webpack_public_path__ + "static/media/lime-not-selected.25df4252.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tags/lime-not-selected.svg
// module id = 64
// module chunks = 0